import React from 'react';
import { Button, Icon, Modal } from 'lmc-ui-library';
import styles from './../../CaseDetailsPage.module.scss';

interface Props {
  errors: string[];
  isOpen: boolean;
  onClose: () => void;
}

const GenerateDocumentsErrorModal: React.FC<Props> = ({ errors, isOpen, onClose }) => {
  return (
    <Modal showCloseBtn={true} isOpen={isOpen} onClose={onClose}>
      <Modal.Header title="Error!" mode="error" className={styles.modalHeader} />
      <Modal.Content>
        <div className={styles.contentText}>
          {errors.map((error) => {
            return (
              <div className={styles.errorItem}>
                <Icon type="warning" color="#FA5245" />
                <div className={styles.errorText}>{error}</div>
              </div>
            );
          })}
        </div>
      </Modal.Content>
      <Modal.Footer style={{ display: 'grid' }}>
        <Button mode="ghost" borderVariant="rectangle" className={styles.actionButton} onClick={() => onClose()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GenerateDocumentsErrorModal;
